import { ItemResultLayoutComponentsProviderComponentBase } from '../../../layouts/item-result/ItemResultLayoutComponentsProviderComponentBase';

export abstract class WireCutItemResultLayoutComponentsProviderComponentBase extends ItemResultLayoutComponentsProviderComponentBase {
  // protected override readonly productDetailStore = inject(StandardProductDetailsComponentStore);
}
